import { type ReactNode } from "react";
import { IconType } from "../icon/IconType";

export type MessageType = "warning" | "info" | "error" | "success";

export interface MessageProps {
  message?: string;
  type: MessageType;
  className?: string;
  children?: ReactNode;
  onClick?: () => void;
}

export const MESSAGE_ICONS = {
  warning: IconType.Warning,
  error: IconType.ErrorCircle,
  info: IconType.InformationCircle,
  success: IconType.CheckCircle,
};
